export default {
title: 'AELU',
ssv: 'විශේෂිත නිපුණතා සහිත වීසා',
what_ssv: 'විශේෂිත නිපුණතා සහිත වීසා යනු?',
representative_message: 'නියෝජිත පණිවිඩය',
aeru_feature: 'AELUහි විශේෂාංග',
aeru_how_to_use: 'භාවිත කරන ආකාරය',
aeru_q_a: 'ප්‍රශ්න සහ පිළිතුරු',
aeru_function: 'AELU හි කාර්‍යයන්',
aeru_fee: 'AELU හි ගාස්තු',
login: 'ඇතුල්වීම',
db_top_comment1: 'කර්මාන්තයේ ප්‍රමුඛයා! "විශේෂිත නිපුණතා සහිත වීසා සඳහා විභාග "සඳහා දුරකථන මාර්ගයෙන් සිදු කරන අන්තර්ජාල පුහුණු වෙබ් අඩවිය',
db_top_comment2: 'AELU යනු විශේෂිත නිපුණතා සහිත වීසා ලබා ගැනීමට ඇති විභාග අධ්‍යනයන් හා විභාග තොරතුරු ,අයදුම් කිර්‍ර්මට යනාදි සේවාවන් සපයන නියෝජිත වෙබ් අඩවියකි.',
db_top_pr: '"ඔබගේ විශේෂිත නිපුණතා වීසා බල පත්‍රය " නව අවස්ථා අත්පත් කර ගැනීමට භාවිත කරමු.',
member_regist: 'සාමාජිකයින් ලියාපදිංචි කිරීම',
registration_support_organization: 'ලියාපදිංචි වීමට සහය වන සවිධානයක් යනු කුමක් ද?',
rso_dec1: 'විශේෂිත නිපුණතා ක්‍රියාවලියේ සංවිධාන 2කි."විශේෂිත නිපුණතා හා අනුබද්ධ සංවිධාන"ලියාපදිංචි සහායක සංවිධාන"යනුවෙනි.විශේෂිත නිපුණතා හා අනුබද්ධ සංවිධාන යනු, විශේෂිත වූ කුසලතා ඇති විදේශිකයින් සේවයේ යොදවන සමාගමකි.(භාරගනු ලබන සංවිධානයකි) විශේෂිත නිපුණතා හා අනුබද්ධ සංවිධාන විශේෂිත නිපුණතා ඇති විදේශිකයන්ගේ රැකියාවට, දෛනික ජීවිතයට සහ සමාජීය කාර්‍යයන් සඳහා සහය ලබා දිය යුතුය.',
rso_dec2: 'විශේෂිත නිපුණතා ඇති විදේශිකයන්ට සහය දැක්වීමේදී විශේෂිත වූ අන්තර්ගතයන් ඇති හෙයින් විශේෂිත නිපුණතා ඇති විදේශිකයන් සේවයේ යොදවන සමාගම් වලටම(විශේෂිත නිපුණතා හා අනුබද්ධ සමාගම්)සිදු කරගෙන යාම අපහසු වන අවස්ථා ද තිබේ.ලියාපදිංචි සහායක ආයතන යනු විශේෂිත නිපුණතා හා අනුබද්ධ ආයතනයන්ට භාර දී ඇති විශේෂිත නිපුණතා ඇති විදේශිකයන් සඳහා අවශ්‍ය සැලැස්මක් නිර්මාණය කිරීම හා ක්‍රියාත්මක කරන සංවිදානයකි.',
rso_dec3: 'ලියාපදිංචි සහායක සංවිධානයක් යනු, විශේෂිත නිපුණතා හා අනුබද්ධ ආයතනයන්ට භාර දී ඇති විශේෂ නිපුණතා ඇති විදේශිකයන්ට අවශ්‍ය ආධාරක සැලැස්මක් නිර්මාණය කර ඒවා ක්‍රියාත්මක කිරීමට කැප වූ සංවිධානයකි.',
rso_dec4: 'ලියාපදිංචි සහායක සංවිධාන, භාර ගන්නා ආයතන සහ සහය ලබා දීමට කැපවන බවට ඇති අංක 1 විශේෂිත නිපුණතා ඇති විදේශිකයන්ට සහය වන සැලැස්ම මත පදනම්ව සියලුම සහයන් සිදු කරයි',
rso_dec5: 'ලියාපදිංචි සහයක සංවිධානයක් වීමට නම් ජපානයේ ආගමන විගමන කාර්‍යංශයේ කොමසාරිස් විසින් ලියාපදිංචි කළ යුතුය.',
rso_dec6: 'ලියාපදිංචි ආයතන , ලියාපදිංචි සහායක සංවිධාන නාමාවළියේ /නිර්දේශිත ලැයිස්තුවෙ ලියාපදිංචි කිරීමෙන් පසු ජපානයේ ආගමන කාර්‍යංශයේ වෙබ් අඩවියේ පළ කරනු ලැබේ.',
rso_dec7: 'ලියාපදිංචි කාලය අවුරුදු 5ක් වන අතර ඉන්පසු නැවත අලුත් කළ යුතුය.',
rso_dec8: 'ලියාපදිංචි සහායක සංවිධාන ජපානයේ ආගමන විගමන කාර්‍යංශයට අවශ්‍ය අවස්ථාවන් වලදී විවිධ දැනුම් දීම් සිදු කළ යුතුය',
article1: 'විශේශ නිපුණතා සහිත වීසා යනු?',
article1_dec1: '2018 දෙසැම්බර් 8 වන දින සිට සංශෝධිත සංක්‍රමණ පාලන පනත මඟින් විශේෂ නිපුණතා සහිත පුද්ගලයින් ජපානයට වීසා ලබා දීම ස්ථාපිත කෙරිණි.එය 2019 වර්ශයේ අප්‍රේල් මස සිට ක්‍රියාත්මක කරන ලදී.',
article1_dec2: 'විශේෂ නිපුණතා සහිත අය ජපානයට පදිංචි වීමට ගෙන්වා ගැනීම අදියර 2ක් යටතේ ස්ථාපිත කෙරේ. (අංක 1,අංක 2)',
article1_dec3: 'ඉලක්ක ගත කර්මාන්ත 14කි.',
article1_dec4: 'ඉලක්කක ගත විදේශිකයින්ගේ වැදගත් කරුණු ලෙස "සැලකිය යුතු දැනුමක් මෙන්ම පළපුරුද්දක් සහිත අවශ්‍ය කුසලතා ඇති පුද්ගලයෙක් වීම.එනම් වසර 3ක කාලයක් තාක්ෂණික පුහුණුව සම්පූර්ණ කළ හා ජපන් භාෂා ප්‍රවීණතා පරීක්ෂණයෙන් සමත් වූවන් ඉලක්ක කොට ඇත.',
article1_dec5: 'විශේෂ නිපුණතා අංක 1 යටතේ විශේෂ නිපුණතා ඇති පුද්ගලයෙකු වශයෙන් උපරිම් වසර 5ක් දක්වා රැඳී සිටීමට අවසර ඇත.නමුත් පවුලේ සාමාජිකයින් සමග ජීවත් වීමට අවසර ලබාදෙනු නොලැබේ.',
article1_dec6: 'විශේෂ නිපුණතා අංක 2 යටතේ නිපුණතා , කුසලතා ඇති අයකු ලෙස අංක 1 විශේෂ නිපුණතා කාලය තුළ විශේෂිත වු විභාගයකින් සමත් වීමෙන් සාමාන්‍ය සේවකයෙකුට ලැබෙන රැකියා සහ පදිංචිය සම්බන්ධ වරප්‍රසාද හිමි වේ.(රැඳී සිටින් කාලය අලුත් කිරීම තුළින් ස්ථිරව පදිංචි වීමේ හැකියාව ද ,පවුලේ සාමාජිකයින් සමඟ ජීවත් වීමට ද අවසර ලබා දෙනු ඇත.',
article2: 'නියෝජිත පණිවිඩය',
article2_sub1: 'එතෙක් ජපානය අත් නොහරින්න',
article2_dec1: 'තාක්ෂණික අභ්‍යාසලාභීන් ලෙස ජපානයට පැමිණ නිපුණතා අත්පත් කර ගත් සහ තමන්ගේ රටේ සංවර්ධනය සඳහා උත්සහය අත්නොහැර සිටි සහ තම මවු රටට යන පුහුණු කරුවන්ට අපගේ ස්තූතිය පළ කිරීමට කැමැත්තෙමු.දැනට ජපානයෙ නොමැති අතහැර යමක් සාත්ෂාත් කර ගැනීම සඳහා දේවල් තෝරා නොගෙන තම පවුල සහ මවු රට වෙනුවෙන් කැපවීම සැබෑ මානුෂික ගුනාංගයක් යැයි සිතමි.තාක්ෂනික අභ්‍යාසලාභීන් සිදු කරන ව්‍යාපාර තුළ තාක්ෂනික අභ්‍යාසලාභී වීසා බල පත්‍රය සමඟ පමණක් රට තුලට ඇතුළත් වීමට ක්‍රමයක් නොමැති අතර ජපානයේ නිසියාකාරව පුහුණුව ලබා , තම මවු රටේ ව්‍යාපාර ආරම්භ කර ,දියුණු කරගෙන යන ආකාරය බහුලව දුටුවෙමි.නමුත් නිශ්චිත වසර ගණනකින් අධ්‍යනය කර අවසන් කල නොහැකි,තවද ජපානයේ දී කුසලතා සංවර්ධනය කර ගත යුතු යැයි යන අධිෂ්ඨානය ඉටු කර ගැනීමට හැකි වන "තාක්ෂණික අභ්‍යාසලාභී වීසා" 2019 අප්‍රේල් මස ස්ථාපිත කරන ලදී.වර්තමානයේ ජපානයේ දුර්ලභ ,ළඟා වීමට අපහසු අරමුණුවලට ළඟා වන විදේශික යින් සමග ජපානය දියුනු කිරීමට හැකිවේ දැයි සිතමු.අන් කිසිවකටත් වඩා ජපානය යන රටට ආදරය වී,ස්ථිර පදිංචි කරුවන් වැඩි වී එකට වාසය කිරීමට හැකිවන සමාජයක් නිර්මාණය කිරීමට හැකි වේදැයි සිතමි.',
article2_dec2: 'සීමාසහිත පුද්ගලික සමාගම් දෘශ්‍යකරණය',
article2_dec3: 'සභාපති සහ ප්‍රධාන විධායක නිළධාරි',
article2_dec4: 'කසුහිතො හොරිඋචි',
article3: 'AELU තුළින් සපයන සේවාවන් 3කි.',
article3_sub1: 'අන්තර්ජාලය හරහා විභාග සඳහා අධ්‍යනයන් සිදු කිරීම.',
article3_sub1_dec1: 'විශේෂ නිපුණතා පරීක්ෂණ විභාගය සඳහා සූදානම් වීමට පියවරක් ලෙස AELUහි පසුහිය ප්‍රශ්න පත්‍ර ආදී කර්මාන්ත 14කට අදාළ ප්‍රශ්න 30ක් අදාල ක්ශේත්‍රයන් වල ප්‍රවීණයන් පිළියෙළ කර, දුරකථනය ඔස්සේ අධ්‍යනය කිරීමට පහසුකම් සලසනු ලැබේ.විභාගයට ප්‍රථම කිහිප වරක්ම පුහුණු විය හැකි අතර AI විසින් සපයනු ලබන ප්‍රශ්න සඳහා ඔබ නිශ්චිත ලකුණු ප්‍රමාණය ඉක්මවා ගතහොත් නිසැකවම විභාගය සමත් වනු ඇත.',
article3_sub2: 'විභාගය පිළිබඳ විස්තර',
article3_sub2_dec1: 'ජපානයට පැමිනෙන විදේශිකයින් සඳහා තේරුම් ගැනීමට ඉතා අපහසු වන විභාග පිළිබඳ තොරතුරු ,ලියාපදිචි වීමෙන් පසු තෝරාගත් කර්මාන්තයට අදාල පරීක්ෂණ පිළිබඳ තොරතුරු ඇතුළත් කළ විට ස්වයංක්‍රීයව එකතු වන අතර පරිශීලකයාට දන්වනු ලබයි.',
article3_sub3: 'විභාග අයදුම්පත් ඒජන්සිය',
article3_sub3_dec1: 'විභාග තොරතුරු සහ විභාග අයදුම් කිරීම සම්බන්ධව නම් ,ජපානයට පැමිණෙන විදේශිකයන් අන්තර්ජාලය හරහා සම්බන්ධ වී අයදුම් කිර්‍ර්මකින් තොරව විභාගයට මුහුණ දීමට පවා නොහැකිය.ලියාපදිංචි වීමෙන් අනතුරුව තොරතුරු ලබා දෙන අතර ,අයදුම් පත්‍රය ඒ වන විටත් අයදුම්කරුවා වෙනුවෙන් පවතින අතර විභාගය පවත්වන බව දැනුම් දීමක් සිදු කරන විටම අයදුම් කිරීමට හැකිවන පරිදි සකසා ඇත.',
article4: 'විභාගය සමත් විමෙන් අනතුරුව සිදි කරන හැඳින්වීම',
article4_sub1: 'සමත් වූවන්ට සුභාශිංසන එක කිරීම (රට තුළ සිටින හො නොමැති) නැවත මුදල් හෝ ලබා දීම (cash back)',
article4_sub1_dec1: 'ජපානයේ පදිංචි වී සිටින පුද්ගලයින් AELU භාවිත කර විභාග සමත් වී, තමන්ගෙ විභාග අංකය සහ විභාග සහතික පත්‍රය පරිශීලක තිරයට(screen) උඩු ගත (upload) කරහොත් එදිනම cash back ලබා ගත හැකිය.cash back වශයෙන් online ත්‍යාග වවුචර් පත්,amazon ත්‍යාග වවුචර් පත්,google play,i tune ත්‍යාග වවුචර් පත් (ඊ මේල් හරහා)යෙන් 5000ක් පමණ වටිනාකමක් ඇති ත්‍යාග LINE සමාජ ජාලය ඔස්සේ ලබා දෙනු ලැබේ.',
article4_sub2: 'මිතුරන් හට හදුන්වාදීම',
article4_sub2_dec1: 'වර්තමානයේ රට තුල හෝ විදේශිකව පදිංචි වී සිටින ජපානයට පැමිණීමට බලාපොරෝත්තුවෙන් සිටිනන් ෆේස් බුක් ග්රූප් එක සමග සම්බන්ධ කර , අදාළ පරිශීලකයා විසින් ඔහුගේ අංකය ලබාදුන්විට ඒ අංකයට අදාළව ත්‍යාග ලබාදෙන අතර ,ඇතුලත් වී මසකට පසු එම හදුන්වාදුන් පුද්ගලයා හට අන්තර්ජාලය හරහා ත්‍යාග වවුචර්පත් යෙන් 1000 ලබා දෙනුලැබේ .',
article4_sub3: 'වීසා ලබාගැනීමෙන් පසු රැකියාව සොයාගැනීම සදහා AI ස්වයංක්‍රීයව ගැලපීම(තීරණය කර නොමැත.)',
article4_sub3_dec1: 'AELUභාවිතාකර , විභාග පරීක්ශනයෙන් සමත්වූ පසු, පරිශීලක තිරයෙහි සමත් අංකය , සමත් වූ බවට සහතිකපත උඩුගත කිරීම සිදුකල පසු ,ජපානය තුල ඇති සෑම ව්‍යාපාරයකින්ම ඔබට ස්වයංක්‍රීය රැකියා අවස්ථා ලැබෙනු ඇත. සම්මුඛ පරීක්ශණද අන්තර්ජාලය හරහා පවත්වන අතර, ප්‍රාරම්භක අවස්ථාවේ වුවද අන්ත්ර්ජාලය හරහා සම්බන්ධ වෙමින් ඔබට විශ්වාසයකින් යුතුව ජපානයට ඇතුළු වී රැකියාවට යා හැකිය!',
article4_sub4: 'පදිංචි සනාථකිරීමේ සහතිකය නියමිත කාලයට පරීක්ෂා කිරීමෙන් මුදල් ආපසු ලබා ගැනීම (තීරණය කරනැත)',
article4_sub4_dec1: 'පදිංචි සනාථකිරීමේ සහතිකය පරික්ෂා කිරීමේ ඇප්එක වන "වන් චෙක් ටැබ්" නොමැතිව මසකට වරක් ඔබ ඔබේ පදිංචි කාඩ්පත පරීක්ෂා කළහොත්, ඔබට වසරක් තුළ යෙන් 10,000 මුදල් ආපසු ලැබෙනු ඇත.',
article5: 'ක්‍රියාකරන ආකාරය පිළිබද සවිස්තරාත්මක හැදින්වීම',
article5_sub1: 'ඔබ විසඳූ ගැටලු දෙස ආපසු හැරී බැලිය හැකිය',
article5_sub1_dec1: 'ඔබ විසින් පුහුණු වූ විභාග අන්තර්ගතයන් ගබඩා කර ගත හැකි වන අතර , මෙවලම් භාවිතා කර, පරිශීලකයාගේ වැරදි තේරුම් ගැනීමට සහ එම ගැටලු මඟහරවා ගැනීමට හැක . ඔබට කැමති වාර ගණනක් පරීක්ෂණයට සූදානම් විය හැකි බැවින්, සියලු ලකුණු ඉතිහාසය සහ පරීක්ෂණ කාලය සටහන් කර එය විභාග පරීක්ෂණය පවත්වන දිනට හැකි තරම් සමීප වන තෙක් පුහුණුවන්න .ඊට අමතරව, ඔබේ මව් භාෂාවෙන් සහ ජපන් භාෂාවෙන් ලියා ඇති නිසා ඔබට ප්‍රශ්නය වඩා හොඳින් තේරුම් ගත හැකිය.',
article5_sub2: 'ජපානයට ඇතුල් වන අවස්ථාවේදී ලබාදුන් ජිවදත්ත පත්‍රිකාව නිත්‍ය ලෙස සංරක්ෂණය කර ඇත.',
article5_sub2_dec1: 'ඔබ විශේෂ නිපුණතා වීසා පරීක්ෂණයකට භාජනය වී වීසා බලපත්‍රයක් සඳහා අයදුම් කරන විට, ඔබ තාක්‍ෂණික සීමාවාසික පුහුණුවන්නෙකු ලෙස ජපානයට ඇතුළු වන විට දුන් ජිවදත්ත පත්රිකාව අවශ්‍ය වේ. කළමනාකරණ ආයතනයක් (හවුල් ව්‍යාපාර) හෝ යැවීමේ සංවිධානය විසින් ජිවදත්ත පත්රිකාව ගබඩා කර ඇති අතර, විශේෂිත නිපුණතා වීසා බලපත්‍රයක් ලබා ගැනීමෙන් පසු ඔබට එය පෞද්ගලිකව තබා ගත හැකිය.',
article5_sub3: 'තමන්ගේ රට සහ ක්ෂේත්‍ර ලියාපදිංචි කිරීමේ කාර්යය',
article5_sub3_dec1: 'ඔබගේ මව්භාෂාව සහ ජපන් භාෂාව එකට භාවිතා වන බැවින්, ඔබට ප්‍රශ්න හොඳින් වටහා ගත හැකි අතර අදාළ පියවර ගත හැකිය. විභාගයේදී, ලබා ගත හැක්කේ ජපන් භාෂාවෙන් පමණි, එබැවින් ඔබට අදාළ පියවර ගත හැක්කේ ජපන් භාෂාවෙන් පමණි.',
article5_sub4: 'විභාග පරීක්ෂණ අවශ්‍යතා සහ තොරතුරු මතක් කිරීම',
article5_sub4_dec1: 'එක් එක් පරීක්ෂණ කණ්ඩායම විසින් අපේක්ෂිත රැකියාව සඳහා වන පරීක්ෂණ කාලසටහන HP වෙත උඩුගත (upload)කළ විට, එය ස්වයංක්‍රීයව මතක් කරනු ලැබේ, පරිශීලකයාට දැනුම් දෙනු ලැබේ, පරීක්ෂණ දිනය පරිශීලක තිරය මත සැකසෙනු ඇත, සහ ටයිමරය ස්වයංක්‍රීයව ක්‍රියාත්මක වේ.',
article5_sub5: 'ස්ක්‍රීන් භාවිතා කරමින් ඉගෙනීම',
article5_sub5_dec1: 'පරිශීලකයාගේ දුර්වල කරුණු දුරවබෝධ කර ගෙන විභාගයට සූදානම් විය හැකිය.',
article5_sub6: 'ස්මාර්ට්ෆෝන් වල කැමරා භාවිතා කරමින් ඉගෙනුම් උපදේශන සහ සම්මුඛ සාකච්ඡා',
article5_sub6_dec1: 'AELUභාවිතාකර භාවිතා කරමින් විභාග සූදානම සමඟ ඉදිරියට යන අතරතුර, ඔබට ඇමතුම් සහ කෙටිපනිවුඩ හුවමාරු කරගැනීම මගින් ප්‍රශ්නයේ අර්ථය සහ ව්‍යුහය පැහැදිලි කර ගත හැකිය. ජපානයට හුරුවී සිටින හෝ හුරුපුරුදු අයට එය අවශ්‍ය නොවනු ඇත, නමුත් මූලික ඇමතුම් උපදේශන සේවාව විභාගයට පෙර ඕනෑම ගැටළුවක් තහවුරු කර ගැනීමට වඩාත්ම සැනසිලිදායක ක්‍රමයකි !',
article6: 'ගාස්තු',
article6_sub1: 'භාවිතා කිරීමේ ගාස්තු',
article6_sub1_dec1: 'විශේෂ නිපුනතා වීසා පරීක්ෂණය සඳහා ඔබට කිසිදු සීමාවකින් තොරව ඉගෙන ගත හැකිය.ඔබට ඔබේ මව් බසින් අන්තර්ජාලය හරහා උපදෙස් ලබා ගත හැකිය. * සාමාන්‍යයෙන්, ඔබට එය පරිවර්තන සදහා භාවිතා කළ හැකිය. විභාග පරීක්ෂණ දිනය,ස්ථානය නිවේදනය කිරීම කලහැකිය.ජපානයට ඇතුළුවන විට තිබෙන ජිවදත්ත පත්‍රිකාව නිත්‍ය වශයෙන් තබා ගත හැක. විභාගය සමත්වීමෙන් පසු, ඔබේ විශේෂ නිපුණතා වීසා බලපත්‍ර අංකය ලියාපදිංචි කරන්න, එවිට අපි ඔබට අපේක්ෂිත රැකියාව හඳුන්වා දෙන්නෙමු. (තීරණය නොකළ)',
article6_sub2: 'විභාග අයදුම්පත් ඒජන්සිය',
article6_sub2_dec1: 'ඔබට රැකියාව අතරතුර අයදුම් කළ නොහැකි අතර, අයදුම් නොකර ඔබට විභාග පරීක්ෂණයට මුහුණ දීමට නොහැකි වනු ඇත, එබැවින් විභාග පරීක්ෂණ තොරතුරු ලබා ගත හැකි වහාම අපි අයදුම් කරන්නෙමු, එවිට ඔබට විභාග දිනය අතපසු නොවනු ඇත.',
article7: 'මුදල් ආපසු ගෙවීමේ වැඩසටහන (Cash Back) ක්‍රියාත්මක වෙමින් පවතී!',
article7_dec1: 'විභාගය සමත්වූ අයගෙන් මෙම සේවාව සඳහා වීසා අංකය ලියාපදිංචි කළ අයට යෙන් 5,000 ක මුදල් ආපසු ගෙවීමක්(Cash Back) ලැබෙනු ඇත! එම වැඩසටහනට සහභාගී වන ආකාරය සඳහා මෙහි ක්ලික් කරන්න',
article8: 'දැන් අපි AELU සමඟ ලියාපදිංචි වෙමු!',
dashboard: 'පාලකපුවරුව',
member_info: 'සාමාජික තොරතුරු ලියාපදිංචි කිරීම',
first_name: 'මුල් නම',
midle_name: 'දෙවෙනි නම',
family_name: 'වාසගම',
half_width_Roman: 'කුඩා(simple) රෝමානු අකුරු',
password: 'මුරපදය',
password_confirm: 'මුරපදය( තහවුරුකිරීම )',
mail_adress: 'විද්‍යුත් තැපෑල',
lineId: 'ලයින්( LINE)අංකය (ඇමතුම් ලබාගැනීමේ සේවාවේදී අවශ්‍ය වේ.)',
country_id: 'රටට අදාළ කේතය',
phone: 'දුරකථන අංකය',
issuing_country: 'හැඳුනුම්පත් නිකුත් කරන රට / කලාපය තෝරන්න',
IDtype: 'හැඳුනුම්පත් වර්ගය තෝරන්න',
residence_card: 'පදිංචිසහතිකපත හෝ හැඳුනුම්පත',
passport: 'මුරපදය',
regist: 'ලියාපදිංචි වීම',
is_required: 'අත්‍යවශ්‍ය වේ',
sign_up: 'අලුතින් ලියාපදිංචිවීම',
residence_front: 'පදිංචිය තහවුරුකිරීමේ කාඩ්පතෙහි මතුපිට උඩුගතකරන්න (upload)',
residence_back: 'පදිංචිය තහවුරුකිරීමේ කාඩ්පතෙහි පිටුපස උඩුගත කරන්න(upload)',
passport_upload: 'මුරපදය යොදන්න',
error_file: 'ස්ක්‍රීන් එක උඩුගත කරන්න (upload)',
post_resume: 'ජිවදත්ත පත්‍රිකාව භාරදෙන්න',
resume_upload: 'ජිවදත්ත පත්‍රිකාව ඇතුලත්කරන්න',
click_upload: 'ක්ලික් කර උඩු ගත කරන්න (click & upload)',
image_drop: 'ලියකිවිල්ල සහිත ෆයිල් එක අමුණන්න(drag & drop)',
select_language: 'මවු භාෂාව තෝරන්න',
vietnamese: 'වියට්නාම භාෂාව',
chinese: 'චීන භාෂාව',
english: 'ඉංග්‍රීසි භාෂාව',
khmer: 'ක්මේර් භාෂාව(කාම්බෝජියනු)',
indonesian: 'ඉන්දුනීසියානු භාෂාව',
tagalog: 'තගලොග් භාෂාව( පිලිපීනය)',
burmese: 'බර්මීස් භාෂාව (මියන්මාර්)',
hindu: 'හින්දි භාෂාව',
lao: 'ලාඔ භාෂාව',
mongolian: 'මොන්ගෝලියනු භාෂාව',
bengali: 'බෙන්ගාලි භාෂාව',
sinhala: 'සිංහල භාෂාව',
banglodesh: 'බංගලාදේශ භාෂාව',
malay: 'මැලේ භාෂාව',
nepali: 'නේපාල් භාෂාව',
thai: 'තායි භාෂාව',
japanese: 'ජපන් භාෂාව',
error_lang: 'මවු භාෂාව තෝරන්න',
select_ouccupation: 'රැකියා වර්ගය',
select_max_three: 'උපරිම වශයෙන් 3ක දක්වා තේරිම් කළ හැකිය',
industry_id_1: 'සාත්තු සේවිකා වෘත්තීය',
industry_id_2: 'ගොඩනැගිලි පිරිසිදු කිරීම',
industry_id_3: 'අමු ද්‍රව්‍ය කර්මාන්තය',
industry_id_4: 'කාර්මික යන්ත්‍රෝපකරණ නිෂ්පාදන කර්මාන්තය',
industry_id_5: 'විදුලි හා විද්‍යුත් තොරතුරු ආශ්‍රිත කර්මාන්ත',
industry_id_6: 'ඉදිකිරීම් කර්මාන්තය',
industry_id_7: 'නැව් තැනීම /සමුද්‍ර කර්මාන්තය',
industry_id_8: 'වාහන නඩත්තු කර්මාන්ත',
industry_id_9: 'ගුවන් සේවා කර්මාන්ත',
industry_id_10: 'නවාතැන් පහසුකම් ලබා දෙන කර්මාන්ත',
industry_id_11: 'කෲෂි කර්මාන්තය',
industry_id_12: 'මත්ස්‍ය කර්මාන්තය',
industry_id_13: 'ආහාර පාන නිෂ්පාදන කර්මාන්තය',
industry_id_14: 'අවන්හල් ව්‍යාපාර',
industry: 'කර්මාන්ත',
error_occupation: 'රැකියා වර්ග එකකට වඩා තෝරන්න',
do: 'කරන්න',
news_tpic: 'ප්‍රවෘත්ති',
days_until_exam: 'විභාගය දක්වා ඉතිරි දවස්',
estimated_pass_rate: 'ඇස්තමේන්තුගත සමත් අනුපාතය',
average_score_taken: 'විභාගයෙ සාමන්‍ය ලකුණු',
exam: 'විභාගය',
let_aim: 'අරමුණු කරගමු',
score: 'ලකුණු',
solve_problem: 'ගැටලු විසඳීම',
recommend_problem: 'AELU හි නිර්දේශිත ගැටලු',
solved_problem: 'විසදන ලද ගැටලු',
looking_solved: 'පසු ගිය ප්‍රශ්න බැලීම',
consultaion_service: 'ශිෂ්‍ය උපදේශන සේවාව',
application_agency: 'විභාග අයදුම්පත් සේවාව',
billing: 'අය කිරීම',
more_look: 'තවත් දුරටත් බැලීම',
more_look2: 'තවත් දුරටත් බැලීම',
facebook: 'ෆේස් බුක්',
google: 'ගූගල්',
until_not_account: 'තවම ගිණුමක් නොමැති අය',
or: 'හෝ',
other_way: 'වෙනත් ක්‍රමයකින්',
not_have_account: 'ගිණුමක් නොමැති අය',
have_account: 'ගිණුමක් ඇති අය',
forgot_password: 'රහස් අංකය අමතක අය',
this: 'මෙතනින්',
at_login: 'ඇතුල් වෙන්න (log )',
pass_condition: 'කැපිටල් ,සිම්පල් අකුරු සහ ලකුණක් ද සහිතව අකුරු 8 කට වැඩි',
at_sign_up: 'නව ලියාපදිංචිය',
agreement1: 'පහත සඳහන් දේට එකඟ වීමෙන් සහ ඉදිරියට යාමට තෝරා ගැනීමෙන් AELU හි',
terms: 'සේවා කොන්දේසි වලට',
agreement2: 'එකඟ වීම',
agree: 'එකඟ වී ඉදිරියට යාම',
account_confirm: 'තහවුරු කිරීමේ කේතය',
confirm: 'තහවුරු කිරීම',
not_confirm: 'තහවුරු කිරීමේ කේතය තහවුරු කර නොමැත',
move_confiirm: 'තහවුරු කිරීමේ කේතය තිරයට ගෙන ඒම (screen)',
top: 'ඉහළට',
news_list: 'ප්‍රවෘත්ති ලැයිස්තුව',
problim_list: 'ප්‍රශ්න ලැයිස්තුව',
learning_consul: 'ශිෂය උපදේශනය',
agency: 'විභාග තොරතුරු',
of_trend: 'විභාගයේ ප්‍රවණතාවය පිළිබඳ',
start_test: 'විභාගය ආරම්භ කිරීම',
study_mode: 'ඉගෙනුම් ආකාර',
order_question: 'ප්‍රශ්නය',
of_question: 'ප්‍රශ්නය අතරතුර',
question_current: 'ප්‍රශ්නයට නිවැරදි පිළිතුර',
to_mypage: 'මගේ පිටුව (my page) වෙත',
correct_answer: 'නිවැරදි පිළිතුර!',
correct_answer_normal: 'නිවැරදි පිළිතුර',
no_correct_answer: 'වැරදි පිළිතුර',
next: 'ඊළඟ ප්‍රශ්නය වෙත',
finish_all: 'සියලුම ප්‍රශ්න සඳහා පිළිතුරු සැපයිණි',
your_score: 'ඔබේ ලකුණු',
is: 'වේ',
result_description: 'ඔබට ගැටලු ලැයිස්තුව බලා අනෙතුත් ගැටලු විසඳිය හැකි අතර පෙර විසඳන ලද ගැටලු ලැයිස්තුව ද පෙර පිටුවෙන් පෙරළා බැලිය හැකිය.',
back_quiz_list: 'ගැටලු ලැයිස්තුව බැලීම',
retry: 'නැව්ත වරක් මේ ගැටලුව විසඳීම',
no_description: 'විස්තරයක් නොමැත',
show_ans: 'විසඳන ලද පිළිතුරු බැලීම',
of_solved_problem: 'පෙර විසඳන ලද ගැටලු',
of_solved_problem_list: 'පෙර විසඳන ලද ගැටලු ලැයිස්තුව',
solved_description: 'සාත්තු සේවිකා වෘත්තියෙහි විශේෂ හැකියා සහිත වීසා පර්‍ර්ක්ෂණය සඳහා ඇති ඉගෙනීම් දෙස නැවත බැලිය හැකිය',
before_result: 'පෙර ප්‍රථිඵල',
looking_back: 'නැවත බැලීම',
back_solved_problem_list: 'පෙර විසඳන ලද ගැටලු ලැයිස්තුව බැලීම',
again_retry: 'නැවත වරක් මේ ගැටලුව බැලීම',
done_member_regist: 'සාමාජිකයෙකු ලෙස ලියාපදිංචි වූවාට ස්තූතියි',
done_member_regist_description: 'එක් එක් සේවා, ගාස්තුව ගෙවීමෙන් පසු ලබා ගත හැකි ය.කරුණාකර ඔබේ ගෙවීම් තොරතුරු ලියාපදිංචි කරන්න',
choose_payment: 'ගාස්තුව ගෙවන ක්‍රමය තේරීම',
service_content: 'සේවා අන්තර්ගතය',
test_info_service: 'විභාග තොරතුරු සේවා',
usage_fee: 'භාවිත කිරීමේ ගාස්තු',
test_fee: 'යෙන් 500+බදු',
application_fee: 'යෙන්20 000+බදු',
method_payment: 'ගෙවීම් සිදු කරන ආකාරය',
LINE_pay: 'LINE හරහා ගෙවීම',
line_pay_description: 'QR කේතය තිරයේ ඇති අතර,LINE Pay සේවාව තුළින් ගෙවීම සිදු කරන්න.LINE Pay වලින් ගෙවන විට කළමනාකාරිත්වය විසින් තහවුරු කිරීමට කාලය ගත වනු ඇත.',
save_qr: 'QR කේතය සුරකින්න',
next_stage: 'ඊළඟට',
credit_card: 'credit card',
copmplete_payment: 'ගෙවීම් සිදුකිරීම සාර්ථකයි',
copmplete_payment_descript: 'දැන් ගෙවීම සම්පුර්ණ කර ඇති බැවින්, ඔබට අන්තර්ජාලය හරහා විභාග අධ්‍යයන කාර්යය, විභාග තොරතුරු සහ විභාග අයදුම්පත් නියෝජිත සේවා භාවිතා කළ හැකිය.',
start_sevice: 'සේවාව භාවිතා කිරීම ආරම්භ කරන්න',
to_payment: 'ගෙවීම් තිරය වෙත',
of_news_list: 'ප්‍රවෘත්ති ලැයිස්තුව',
done_payment: 'ගෙවීම් සිදුකිරීම සාර්ථකයි',
tv_consult: 'රූපවාහිනි සහ දුරකථන උපදේශනය',
tell_consult: 'දුරකථන උපදේශනය',
learning_consul_descript01: 'විභාග අයදුම් කිරීම',
learning_consul_descript02: 'නියෝජිතයෙක් ලෙස ක්‍රියා කරයි',
money_unit: 'යෙන්',
learning_consul_unit: 'එක වතාවක්',
fault_payment1: 'ගෙවීම අසාර්ථකයි',
fault_payment2: 'නැවත වතාවක් උත්සහ කරන්න',
no_examination: 'නැවත උත්සහ කරන්න',
no_exam: 'විභාගය තවම නැත',
undecided: 'තීරණය නොකළ',
retry_login: 'කරුණාකර නැවත පුරනය වන්න (login)',
no_problem: 'විසඳූ ගැටලුවක් නොමැත',
do_problem: 'ගැටලු විසඳීම',
qa_title: 'බහුලව ඇති ගැටලු',
search_category: 'කාණ්ඩය අනුව තේරීම',
search_freeward: 'නිදහස් වචනයෙන් සොයන්න',
test_result: 'අනුමාන විභාගවල ප්‍රථිඵල',
to_top: 'ඉහළට',
missPassword: 'මුරපදය හෝ විද්‍යුත් තැපැල් ලිපිනය වැරදි',
sample_problem: 'අන්තර්ජාලය හරහා විභාගයක් සිදු කරන අයුරු අත් විඳිමු',
exercises: 'පුහුණු ප්‍රශ්න',
let_exercises: 'එක් ගැටළුවක් පමණක් විසඳා බලමු!',
to_qa: 'ප්‍රශ්න සහ පිළිතුරු තවත් දුරටත්',
read_more: 'තවත් දුරටත් බැලීම',
account_setting: 'ගිණුම සැකසීම',
profile_setting: 'profile එක සැකසීම',
notification_setting: 'දැනුම්දීම් සැකසුම්',
logout: 'ඉවත් වීම (logout)',
changeEmail: 'ඊ මේල් ලිපිනයේ වෙනස්කම්',
changePassword: 'මුර පදයේ වෙනස්වීම්',
change: 'වෙනස් කිර්‍රීම',
save: 'සුරක්ෂිත කිරීම (save)',
change_success: 'වෙනස් කිරීම සාර්ථකයි',
now_password: 'වත්මන් මුරපදය',
new_password: 'නව මුරපදය',
check_new_password: 'නව මුරපදය තහවුරු කිරීම',
do_logout: 'ඉවත් වීය (logout)',
done_learning_consul_payment: 'ගෙවීම දැනටමත් සාර්ථක වී ඇත.',
past_exam: 'පසු ගිය ප්‍රශ්න',
update_info: 'නවතම තොරතුරු යාවත්කාලීන කිරීම',
official_sns: 'නිල SNS',
privacy_policy: 'රහස්‍යතා සහ ප්‍රථිපත්ති',
terms_service: 'සේවා කොන්දේසි',
transaction_law: 'විශේෂ ගනුදෙනු නීතිය මත පදනම් වූ අංකනය',
selectCountry: 'රට තෝරන්න',
goInquiry: 'විමසීම් සඳහා ඉදිරියට',
lineInquiry: 'LINE හරහා විමසීම',
regist_accept_certificate: 'විශේෂ නිපුණතා වීසා ලබා ගැනීමේ සමත් සහතිකය ලියාපදිංචි කිරීම',
accept_certificate_description: 'ඔබගේ සාමාර්ථ සහතිකය සහ අංකය ලියාපදිංචි කළ හැකිය',
accept_certificate: 'විභාග සාමාර්ථ සහතිකය',
accept_number: 'විභාග අංකය',
immigration_resume: 'රටට ඇතුළත් වන විට ජීව දත්ත පත්‍රිකාව ලියාපදිංචිය',
resendCode: 'තහවුරු කිරීමේ කේතය නැවත යැවීම',
line_at_register: 'LINE@ සේවාව හරහා විමසීම්',
study: 'අධ්‍යනයන් දෙස නැවත බැලීම',
study_text: 'ඉගෙනුම් සඳහා පොත් බාගත කිරීම (Download)',
do_resume_update: 'ජීව දත්ත පත්‍රිකාව උඩු ගතකරන්න . (upload)',
done_resume_update: 'ජීව දත්ත පත්‍රිකාව ලියාපදිංචිය පිළිබඳ ස්තූතියි',
regist_resume_enter: 'රටට ඇතුළත් වන විට ජීව දත්ත පත්‍රිකාව ලියාපදිංචිය',
about_company: 'කළමනණාකරණ සමාගම පිළිබඳ',
add_exam_info_detail: 'විභාග තොරතුරු එකතු කර ඇත. විස්තර සහ අයදුම් කිරීමට මෙහි ක්ලික් කරන්න',
regist_result_get_money: 'ඔබගේ විභාග ප්‍රථිඵල ලියාපදිංචි කර මුදල් ලබා ගන්න',
detail: 'වැඩි විස්තර',
about_withdrawal_subsc: 'ගෙවීම් ඉවත් කර ගැනීම සහ අවලංගු කිරීම ගැන',
apply_withdrawal: 'මුදල් ආපසු ගැනීමේ ක්‍රියා පටිපාටිය සඳහා ඉල්ලුම් කිරීම',
apply_subsc: 'ගෙවීම් අවලංගු කිරීම සඳහා ඉල්ලුම් කිරීම',
about_withdrawal: 'ඉල්ලා අස්කර ගැනීමට අයදුම්කිරීම',
about_subsc: 'ගෙවීමෙන් ඉවත් වීම',
exam_info: 'විභාග තොරතුරු',
date: 'දිනය සහ වේලාව',
day: 'දිනය',
place: 'ස්ථානය',
result_publication: 'ප්‍රතිපල ප්‍රකාශනය',
result_publication_place: 'ප්‍රතිපල ප්‍රකාශ කරන ස්ථානය',
result_this_page: 'මෙම පිටුවෙන් ප්‍රකාශ කරනු ලැබේ.',
exam_way: 'පරීක්ෂණ ආකෘතිය',
exam_way2: 'විභාග ප්‍රශ්න ආකෘතිය',
include_exam_fee: 'පරීක්ෂණ ගාස්තු ඇතුළුව',
exam_application_desc: 'විභාගය සඳහා අයදුම් පත්‍රය ඉදිරිපත් කිරීම නියෝජනය කිරීම \n විභාග කාර්යාලය සමඟ සන්නිවේදනය කිරීම \ n දවස වන විට සූදානම් විය යුතු දේ දැනුම් දීම (LINE @) \ n විභාගය සම්බන්ධ ඕනෑම ප්‍රශ්නයක් සාකච්ඡා කිරීම',
self_application: 'තමන් විසින් අයදුම් කිරීම',
application_method: 'අයදුම් කළ යුතු ආකාරය',
under_this_url: 'කරුණාකර පහත (URL)ලින්ක් එක භාවිතා කර අයදුම් කිරීමේ ක්‍රියා පටිපාටිය සම්පූර්ණ කරන්න',
do_appliction: 'විභාගය සඳහා අයදුම්කිරීම',
study_with_aeru: 'සමත් වීමේ අනුපාතය වැඩි කිරීම සඳහා ඉහළ පිටුවේ විභාග අධ්‍යයන විශේෂාංගය භාවිතා කරන්න',
line_at_consul: 'LINE @ ඉගෙනුම් උපදේශන සේවාව',
instagram: 'Instagram',
do_signup: 'තහවුරු කර ඇත. කරුණාකර නැවත ලොග් වෙන්න.',
gender: 'ස්ත්‍රී පුරුෂභාවය',
man: 'පුරුෂ',
woman: 'ස්ත්‍රී',
input_problem_title: 'ප්‍රශ්නයට අදාල මාතෘකාව යොදන්න',
still_no_problem: 'ප්‍රශ්නයක් නොමැත.',
enter_in_problem_trend: 'මෙතෙක් විභාගයේ ප්‍රවණතා සහ පිළිතුරු ආකෘතිය (තේරීමේ වර්ගය) වැනි විභාගය පිළිබඳ කෙටි පැහැදිලි කිරීමක් අඩංගු වේ.',
correct: 'නිවැරදියි.',
explanation: 'පැහැදිලිකිරිම',
problem: 'ප්‍රශ්න',
do_nursing_not_published: 'සාත්තු සේවිකා වෘත්තියට අදාළව විභාග පවත්වනු ලැබේ, නමුත් කලින් පැවති විභාග ප්‍රශ්නපත්‍ර පොදු භාවිතය සදහා ප්‍රකාශයට පත් කර නොමැත.',
practical_exam_of_year: 'වසර ප්‍රායෝගික පරීක්ෂණය',
judgment_test_of_year: '2019 විනිශ්ච විභාගය',
judgment_test_answer_of_year: '2019 විනිශ්චය විභාගයේ පිළිතුරු',
not_yet_test_material: 'අමුද්‍රව්‍ය කර්මාන්තයට අදාළව තවමත් විභාගයක් පවත්වා නොමැත.',
not_yet_test_machinery: 'කාර්මික යන්ත්‍රෝපකරණ නිෂ්පාදන අංශයට අදාළව තවමත් විභාගයක් පවත්වා නොමැත.',
not_yet_test_electronic: 'විදුලි හා ඉලෙක්ට්‍රොනික තොරතුරු කර්මාන්තයට අදාළව තවමත් විභාගයක් පවත්වා නොමැත.',
not_yet_test_construction: 'ඉදිකිරීම් කර්මාන්තයට අදාළව තවමත් විභාගයක් පවත්වා නොමැත.',
not_yet_test_shipbuilding: 'නැව් තැනීමේ හා සමුද්‍ර කර්මාන්තවලට අදාළව තවමත් විභාගයක් පවත්වා නොමැත',
do_automobile_not_published: 'මෝටර් රථ නඩත්තු ක්‍ෂේත්‍රයේ විභාග පවත්වනු ලැබේ, නමුත් කලින් පැවති විභාග ප්‍රශ්නපත්‍ර පොදු භාවිතය සදහා ප්‍රකාශයට පත් කර නොමැත.',
do_aviation_not_published: 'ගුවන් සේවා කර්මාන්තයට අදාළව විභාග පවත්වනු ලැබේ, නමුත් කලින් පැවති විභාග ප්‍රශ්නපත්‍ර පොදු භාවිතය සදහා ප්‍රකාශයට පත් කර නොමැත.',
do_agricultural_not_published: 'කෘෂිකාර්මික අංශයට අදාළව විභාග පවත්වනු ලැබේ, නමුත් කලින් පැවති විභාග ප්‍රශ්නපත්‍ර පොදු භාවිතය සදහා ප්‍රකාශයට පත් කර නොමැත.',
do_fishery_not_published: 'ධීවර අංශයට අදාළව විභාග පවත්වනු ලැබේ, නමුත් කලින් පැවති විභාග ප්‍රශ්නපත්‍ර පොදු භාවිතය සදහා ප්‍රකාශයට පත් කර නොමැත.',
do_food_not_published: 'ආහාර හා පාන නිෂ්පාදන කර්මාන්තයට අදාළව විභාග පවත්වනු ලැබේ, නමුත් කලින් පැවති විභාග ප්‍රශ්නපත්‍ර පොදු භාවිතය සදහා ප්‍රකාශයට පත් කර නොමැත.',
do_restaurant_not_published: 'අවන්හල් ව්‍යාපාරයට අදාළව විභාග පවත්වනු ලැබේ, නමුත් කලින් පැවති විභාග ප්‍රශ්නපත්‍ර පොදු භාවිතය සදහා ප්‍රකාශයට පත් කර නොමැත.',
schedule_undecided: '(* වැඩසටහන තීරණය කර නොමැත)',
year: 'අවුරුද්ද',
month: 'මාසය',
texts_learning: 'එක් එක් කර්මාන්තයට අදාළ ඉගෙනීම සඳහා පෙළපොත්',
texts_learning_test: 'විශේෂිත නිපුණතා ඇගයීම් පරීක්ෂණය ඉගෙනීම සඳහා වන පෙළපොත (ජපන්)',
skill_test_sample: 'නිපුණතා ඇගයීමේ පරීක්ෂණ නියැදිය',
japanese_test_sample: 'ජපන් ඇගයීම් පරීක්ෂණ නියැදිය',
not_building_texts: 'ගොඩනැගිලි පිරිසිදු කිරීමේ කර්මාන්තය සඳහා තවමත් පෙළපොත් නොමැත',
not_material_texts: 'අමුද්‍රව්‍ය කර්මාන්තයට අදාළව තවමත් පෙළපොත් නොමැත',
not_machinery_texts: 'කාර්මික යන්ත්‍රෝපකරණ නිෂ්පාදන ක්ෂේත්‍රයට අදාළව තවමත් පෙළපොත් නොමැත',
not_electronic_texts: 'විදුලි හා ඉලෙක්ට්‍රොනික තොරතුරු කර්මාන්තයට අදාළව තවමත් පෙළපොත් නොමැත',
not_shipbuilding_texts: 'නැව් තැනීමේ හා සමුද්‍ර කර්මාන්තවලට අදාළව පෙළපොත් නොමැත',
not_automobile_texts: 'මෝටර් රථ නඩත්තු ක්‍ෂේත්‍රයේ පෙළපොත් නොමැත',
not_accommodation_texts: 'නවාතැන් පහසුකම් සැපයීමේ කර්මාන්තවලට අදාළව පෙළපොත් නොමැත',
not_food_texts: 'ආහාර හා පාන නිෂ්පාදන කර්මාන්තවලට අදාළව පෙළපොත් නොමැත',
not_restaurant_texts: 'අවන්හල් ව්‍යාපාරයට අදාළව සේවා නිපුණතා මිනුම් පරීක්ෂණ පෙළපොත්',
each_depertment_texts: 'එක් එක් දෙපාර්තමේන්තුවේ විභාග අධ්‍යයනය සඳහා පෙළපොත',
skill_test_basic: 'නිපුණතා ඇගයීම් පරීක්ෂණ ඉගෙනුම් පෙළ පොත (මූලික නිපුණතා)',
skill_test_safety: 'නිපුණතා ඇගයීමේ පරීක්ෂණ ඉගෙනුම් පෙළපොත(වැඩවලට අදාළ සුරක්ෂිතතාවය සහ ගුණාත්මකභාවය)',
skill_test_aircraft: 'නිපුණතා ඇගයීමේ පරීක්ෂණ ඉගෙනුම් පෙළපොත(ගුවන්යානා සම්බන්ධ සංක්ෂිප්තව තොරතුරු දැක්වීම )',
texts_livestock: '[පශු සම්පත් ගොවිතැන ඉගෙනීම සඳහා පෙළ පොත] ජපන් අනුවාදය',
texts_cultivated: '[කෘෂිකර්මාන්තය පිළිබඳ ඉගෙනීම සඳහා පෙළපොත] ජපන් අනුවාදය',
skill_test_fishery: 'ධීවර කර්මාන්තය සම්බන්ධ නිපුණතා මිනුම් පරීක්ෂණය (ධීවර කර්මාන්තය )',
skill_test_general_fishery: 'ධීවර කර්මාන්තය සම්බන්ධ නිපුණතා මිනුම් පරීක්ෂණය (සාමාන්‍ය ධීවර)',
skill_test_safety_fishery: 'ධීවර කර්මාන්තයට අදාල නිපුණතා මිනුම් පරීක්ෂණය (ධීවර කර්මාන්තය සිදුකිරීමට අදාල සුරක්ෂිතභාවය)',
skill_test_specialty_fishery: 'ධීවර කර්මාන්තයට අදාල නිපුණතා මිනුම් පරීක්ෂණය (ධීවර වෘත්තියට අදාළ දැල් සම්බන්ධ)',
skill_test_related_fishery: 'ධීවර කර්මාන්තයට අදාල නිපුණතා මිනුම් පරීක්ෂණය(මසුන් ඇල්ලීම සම්බන්ධ)',
skill_test_aquaculture: 'ධීවර කර්මාන්තයට අදාල නිපුණතා මිනුම් පරීක්ෂණය (ජලජ ජීවී වගාව)',
skill_test_general_aquaculture: 'ධීවර කර්මාන්තයට අදාල නිපුණතා මිනුම් පරීක්ෂණය (සාමාන්‍ය ජලජ ජීවී වගාව/සුරක්ෂිතතාවය )',
skill_test_feeding_aquaculture: 'ධීවර කර්මාන්තයට අදාල නිපුණතා මිනුම් පරීක්ෂණය (ජලජ ජීවී වගාවට අදාල පෝෂණය සැපයීම )',
skill_test_non_feeding_aquaculture: 'ධීවර කර්මාන්තයට අදාල නිපුණතා මිනුම් පරීක්ෂණය (ජලජ ජීවී වගාවට අදාල පෝෂණය සැපයිමකින් තොරව)',
registration_skill_visa: 'විශේෂ නිපුණතා වීසා සහතිකය ලියාපදිංචි කිරීම',
please_register_pdf_number: 'විශේෂ නිපුණතා වීසා බලපත්‍රයක් ලබා ගැනීම සඳහා කරුණාකර වීසා සහතිකයේ ඡායාරූපයක් හෝ PDF එක සහ එම සහතිකයෙහි ඇති සමත් අංකය සමග ලියාපදිංචි කරන්න.',
regist_and_get_cash_bag: 'ඔබ දැන් ලියාපදිංචි වන්නේ නම්, ඔබට යෙන් 5000 ක් මුදලක් (cash back)ලබා ගත හැකිය',
thank_you_regist_visa_pass: 'විශේෂ නිපුණතා වීසා බලපත්‍රයක් ලබා ගැනීම සඳහා සමත් සහතිකය ලියාපදිංචි කිරීම ගැන ඔබට ස්තූතියි!',
exam_info_detail: 'විභාග ක්‍රියාත්මක කිරීමේ දළ සැලැස්ම',
em_exam_detail_language: 'දේශීය භාෂාවෙන් වැඩසටහන',
em_exam_detail_method: 'දෙපාර්තමේන්තු පරීක්ෂණය, ප්‍රායෝගික පරීක්ෂණය',
em_exam_detail_way: 'පරිගණක පාදක විභාග පරීක්ෂණ (CBT), ප්‍රශ්න පත්‍ර පරීක්ෂණ ක්‍රමය හෝ සැකසීම වැනි වැඩ පරීක්ෂණ ක්‍රම',
em_exam_detail_section: 'විභාග කාණ්ඩ 19(යකඩ සකස් කිරීම,ලෝහ තැලීම,ලෝහ උණුකර සැකසීම,වාත්තු කිරීම , යකඩ පදම් කිරීම ,යකඩ සම්බන්ධ වැඩ , කර්මාන්තශාලා තහඩු ලෝහ,ලොහාලේපනය , ඇලුමිනියම් ඇනෝඩීකරණය, නිම කිරීම, යන්ත්‍ර පරීක්ෂාව, යන්ත්‍ර නඩත්තුව, ඉලෙක්ට්‍රොනික උපකරණ එකලස් කිරීම, විදුලි උපකරණ එකලස් කිරීම, මුද්‍රිත පරිපථ පුවරු නිෂ්පාදනය, ප්ලාස්ටික් නිෂ්පාදන , පින්තාරු කිරීම, වෙල්ඩින් , කාර්මික ඇසුරුම්කරණය)',
em_exam_detail_notify: 'විභාග පරීක්ෂණයෙන් පසුව, ඊමේල් මගින් ප්‍රථිපල දැනුම් දීමක් සිදුකරයි',
em_exam_detail_border: 'දෙපාර්තමේන්තු පරීක්ෂණය: 65% හෝ ඊට වැඩි ප්‍රායෝගික පරීක්ෂණය: ලකුණු 60 හෝ ඊට වැඩි',
ss_exam_detail_language: 'ජපන් භාෂාව',
ss_exam_detail_method: 'ප්‍රවීණතා පරීක්ෂණය, ප්‍රායෝගික කුසලතා පරීක්ෂණයකින් සහ දෙපාර්තමේන්තු පරීක්ෂණයකින් පවත්වනු ලැබේ. එක් එක් ව්‍යාපාර කාණ්ඩය සඳහා ප්‍රායෝගික විභාග පවත්වනු ලැබේ. එක් එක් ව්‍යාපාර කාණ්ඩය සඳහා දෙපාර්තමේන්තු පරීක්ෂණය ප්‍රශ්න පත්‍ර මගින් පවත්වනු ලැබේ.',
ss_exam_detail_way: 'ප්‍රශ්න පත්‍ර පරීක්ෂණ ක්‍රමය සහ වෙනත් .',
ss_exam_detail_section: 'දෙපාර්තමේන්තුව / ප්‍රායෝගික කුසලතා / නිපුණතා: වෙල්ඩින්, පින්තාරු කිරීම, යකඩ වැඩ, නිම කිරීම, යන්ත්‍රෝපකරණ නිෂ්පාදනය , විදුලි උපකරණ එකලස් කිරීම',
ss_exam_detail_notify: '',
ss_exam_detail_border: 'දෙපාර්තමේන්තු පරීක්ෂණය: 60% හෝ ඊට වැඩි ප්‍රායෝගික පරීක්ෂණය: ප්‍රායෝගික පරීක්ෂණ ප්‍රතිඵල මත පදනම් වූ විනිශ්චය',
c_exam_detail_language: 'ජපන් භාෂාව',
c_exam_detail_method: 'ප්‍රවීණතා පරීක්ෂණය, ප්‍රායෝගික පරීක්ෂණයකින් සහ දෙපාර්තමේන්තු පරීක්ෂණයකින් පවත්වනු ලැබේ.',
c_exam_detail_way: 'පරිගණක පාදක පරීක්ෂණ (CBT), ප්‍රායෝගික පරීක්ෂණය යනු ලියාපදිංචි සංස්ථාවක් විසින් නියම කරන ලද ක්‍රමයකි',
c_exam_detail_section: '',
c_exam_detail_notify: 'වෙබ් අඩවියේ ප්‍රකාශයට පත් කරන ලදී',
c_exam_detail_border: 'දෙපාර්තමේන්තු පරීක්ෂණය: 65% හෝ ඊට වැඩි ,ප්‍රායෝගික පරීක්ෂණය: ප්‍රායෝගික ප්‍රතිඵල මත පදනම් වූ විනිශ්චය',
cm_exam_detail_language: 'ජපන් භාෂාව',
cm_exam_detail_method: 'ප්‍රවීණතා පරීක්ෂණය ප්‍රායෝගික කුසලතා පරීක්ෂණයකින් සහ දෙපාර්තමේන්තු පරීක්ෂණයකින් පවත්වනු ලැබේ.',
cm_exam_detail_way: 'පරිගණක පාදක පරීක්ෂණ (CBT) මගින් අධ්‍යයන හා ප්‍රායෝගික විභාග සිදු කිරීම',
cm_exam_detail_section: 'දෙපාර්තමේන්තු විභාගයේ විෂය අ. ව්‍යුහය,ක්‍රියාකාරිත්වය සහ හැසිරවීමේ ක්‍රමවේදය පිළිබඳ මූලික දැනුම ඉ.පරීක්ෂා කිරීම, අළුත්වැඩියා කිරීම හා ගැලපීම පිළිබඳ මූලික දැනුම,පරීක්ෂණ යන්ත්‍රවල ව්‍යුහය, ක්‍රියාකාරිත්වය සහ හැසිරවීමේ ක්‍රමය, මිනුම් උපකරණ සහ නඩත්තු කිරීම සඳහා වන මූලික දැනුම ගුණාංග සහ භාවිතය ප්‍රායෝගික පරීක්ෂණ විෂයයන් අ. සරල මූලික වැඩ ඉ.විසුරුවා හැරීම, එකලස් කිරීම, සරල පරීක්ෂාව සහ ගැලපීම උ.පහසුවෙන් අලුත්වැඩියා කිරීම ,පරීක්ෂණ යන්ත්‍ර හැසිරවීම, මිනුම් උපකරණ සහ මෙවලම් පහසුවෙන් නඩත්තු කිරීම',
cm_exam_detail_notify: '',
cm_exam_detail_border: 'දෙපාර්තමේන්තු පරීක්ෂණය: 65% හෝ ඊට වැඩි ප්‍රායෝගික පරීක්ෂණය: මුළු ලකුණු 60% හෝ ඊට වැඩි',
a_exam_detail_language: 'දේශීය භාෂාව සහ ජපන්',
a_exam_detail_way: 'පරිගණක පාදක පරීක්ෂණ (CBT), කඩදාසි පරීක්ෂණ ක්‍රමය',
a_exam_detail_section: '① පොදුවේ වගා කරන ලද කෘෂිකර්මාන්තය, ආරක්ෂාව සහ සෞඛ්‍යය, වගා කරන ලද භෝගවල ප්‍රභේද / ලක්ෂණ, වගා පරිසරය (පහසුකම් / උපකරණ / ද්‍රව්‍ය / යන්ත්‍රෝපකරණ), වගා ක්‍රමය / කළමනාකරණය, පළිබෝධ / වල්පැලෑටි පාලනය, අස්වනු නෙලීම/ ගැලපීම / ගබඩා කිරීම ② පාංශු නිරීක්ෂණ , පොහොර / පළිබෝධනාශක හැසිරවීම, බීජ හැසිරවීම, පාරිසරික කළමනාකරණය, ද්‍රව්‍ය / උපකරණ / යන්ත්‍ර හැසිරවීම, වගාව, ආරක්ෂාව සහ සෞඛ්‍යය සම්බන්ධ කටයුතු ③ ජපන් ජපන් භාෂාවෙන් උපදෙස් දෙන කෘෂිකාර්මික කටයුතුවල අන්තර්ගතය ඇසීම',
a_exam_detail_notify: 'වෙබ් අඩවියේ ප්‍රකාශයට පත් කරන ලදී',
a_exam_detail_border: 'මුළු අගය ජාතික කෘෂිකර්ම මණ්ඩලය විසින් නියම කරන ලද සම්මත මට්ටම ඉක්මවා යාම',
avi_exam_detail_method: 'ප්‍රවීණතා පරීක්ෂණය ප්‍රායෝගික කුසලතා පරීක්ෂණයකින් සහ දෙපාර්තමේන්තු පරීක්ෂණයකින් පවත්වනු ලැබේ.',
avi_exam_detail_section: 'ජපන් ගුවන් තාක්ෂණ සංගමයේ වෙබ් අඩවියේ පළ කර ඇතිවලින් ප්‍රශ්න ලබා දෙනු ඇත. ප්‍රායෝගික නිපුණතා නිගමනය, විදුලි මිනුම්',
avi_exam_detail_notify: '',
avi_exam_detail_border: 'දෙපාර්තමේන්තු පරීක්ෂණය: 65% හෝ ඊට වැඩි ප්‍රායෝගික පරීක්ෂණය: මුළු ලකුණු 65% හෝ ඊට වැඩි',
f_exam_detail_language: 'ජපන් භාෂාව',
f_exam_detail_method: 'ප්‍රවීණතා පරීක්ෂණය, ප්‍රායෝගික කුසලතා පරීක්ෂණයකින් සහ දෙපාර්තමේන්තු පරීක්ෂණයකින් පවත්වනු ලැබේ.',
f_exam_detail_way: 'පරිගණක පාදක පරීක්ෂණ (CBT) මගින් අධ්‍යයන හා ප්‍රායෝගික විභාග සිදු කිරීම',
f_exam_detail_section: 'පරිගණක පාදක පරීක්ෂණ (CBT) මගින් අධ්‍යයන හා ප්‍රායෝගික විභාග සිදු කිරීම',
f_exam_detail_notify: 'වෙබ් අඩවියේ ප්‍රකාශයට කරන ලදී',
f_exam_detail_border: 'ප්‍රවීණතා පරීක්ෂණ ක්‍රියාත්මක කිරීමේ ආයතනය විසින් නියම කරන ලද සම්මත ලකුණු මට්ටම ඉක්මවා ඇති ලිඛිත පරීක්ෂණය හා ප්‍රායෝගික පරීක්ෂණයෙහි මුළු ලකුණු ලබා ගත් අය සමත් වනු ඇත',
no_exam_info: 'විභාග තොරතුරු කිසිවක් මෙතෙක් නිකුත් කර නොමැත',
language: 'භාවිත කරන භාෂාව',
method: 'භාවිත කරන ක්‍රමය',
way: 'භාවිත කරන ආකාරය',
section: 'විභාග වර්ගීකරණය',
notify: 'විභාග ප්‍රතිඵල දැනුම් දීම',
border: 'විභාග ප්‍රතිඵල සඳහා සූදානම',
go_line_at: 'line වෙත',
thank_you_and_deactivate: 'ස්තූතියි. සේවාවෙන් ඉවත් වීමේ ක්‍රියා පටිපාටිය සඳහා කරුණාකර පහත line ＠කවුළුවෙන් ඉවත් වීම සිදුකරන්න.ගෙවීම අවලංගු කිරීමට, කරුණාකර පහත line @ කවුළුවෙන් ගෙවීම අවලංගු කරන්න.තහවුරු කිරීමක් ලැබුණු වහාම අපි ක්‍රියාත්මක වන්නෙමු',
thank_you_and_subscribe: 'ස්තූතියි. ගෙවීම් අවලංගු කිරීම සඳහා කරුණාකර පහත line ＠ හරහා අවලංගු කරන්න . තහවුරු කිරීම තහවුරු වූ වහාම අපි කොන්ත්රාත්තුව අවලංගු කරන්නෙමු.',
ten_thousand_yen: 'යෙන්100000',
yen_per_month: 'මසයකට යෙන්',
how_to_use_this_service: 'භාවිත කරන පටිපාටිය',
selecting_a_browser: 'browser තේරීම',
selecting_a_browser_dec: 'browser （Googlechrome、Safari、edge යනාදි)https://aelu.co.jp හරහා ලොග් වෙන්න.ඇප් එකක් නැත',
provisional_registration: 'තාවකාලික ලියාපදිංචිය',
provisional_registration_dec: 'ඔබගේ ෆේස්බුක් හෝ ගූගල් ගිණුමෙන් ලොග් වන්න හෝ ඔබේ විද්‍යුත් තැපැල් ලිපිනය සමඟ ලියාපදිංචි වන්න.',
full_registration: 'මූලික ලියාපදිංචිය',
full_registration_dec: 'අන්තර්ජාලය හරහා (online )විභාගයේ අන්තර්ගත පිටුවේ "ලියාපදිංචිය" ක්ලික් කර අවශ්‍ය තොරතුරු පුරවන්න.කර්මාන්ත නිපුණතා විභාග ප්‍රායෝගික ප්‍රශ්න 14 ඇතුළුව සියලුම සේවාවන් භාවිත කළ හැකිය',
name_validate_message: 'කරුණාකර ඔබගේ විදේශ ගමන් බලපත්‍රයේ පෙනෙන ආකාරයටම අක්ෂර වින්‍යාසය සමඟ තොරතුරු ඇතුළත් කරන්න',
live_at_area: 'ඔබ දැනට ජීවත් වන ප්‍රදේශය',
agency_application: 'විභාග අයදුම් සඳහා ක්‍රියා කිරීම',
mypage: 'මගෙ පිටුව (mypage)',
myanmar: 'බිරුම භාෂාව (මියන්මාර්)',
exam_list: 'විභාග කාලසටහන් ලැයිස්තුව',
no: 'අංක',
times: 'වාර ගණන',
application_start: 'අයදුම් කිරීම ආරම්භ කිරීම',
application_end: 'අයදුම්පත් භාරගැනීම අවසන්',
enforcement: 'ක්‍රියාත්මක කිරීම',
applicated: 'අයදුම් කිරීම අවසන්',
reception_time: 'භාරගන්නා වේලාව',
announthment_d: 'විභාග ප්‍රතිඵල නිකුත් කරන දිනය',
reception_period: 'අයදුම් කරන කාලය',
detail_link: 'විස්තර බලන්න',
exam_country: 'පවත්වන රට',
line: 'LINE',
vietnum: 'වියට්නාමය',
laos: 'ලාඕස්',
malaysia: 'මැලේසියා',
bangladesh: 'බංගලාදේශ',
indo: 'ඉන්දියා',
nepal: 'නේපාල්',
mongol: 'මොංගෝලියව',
indonesia: 'ඉන්දුනීසියාව',
th: 'තායිලන්තය',
philipine: 'පිලිපීනය',
my: 'මියන්මාර්',
uzbekistan: 'උස්බෙකිස්තාන්',
pakistan: 'පකිස්තාන්',
japan: 'ජපානය',
news_title: 'විශේෂිත නිපුණතා වීසා බලපත්‍ර පිළිබඳ පුවත්',
missNowPassword: 'වත්මන් මුරපදය වැරදි',
article6_sub2_dec2: 'ඔබ මෙහි අයදුම් කරන්නේ නම් අදාළ දිනය දක්වා අයදුම්පත,ගාස්තු,ස්තානය පිළිබඳ ප්‍රකාශයට පත් කරන්නෙමු',
create_naw_password: 'මුර පදයේ වෙනස්වීම්',
send_confirmcode: 'තහවුරු කිරීමේ කේතය යවන ලදි',
edit: 'වෙනස්කිරීම',
success_new_password_setting: 'නව මුරපදය ස්ථාපිත කරන ලදි.',
error_email: 'වරදි විද්‍යුත් තැපැල් ලිපිනයකි',

click_here_businesses: "ව්‍යාපාර සඳහා මෙහි ක්ලික් කරන්න",
regist_organization_staff_info: "ව්‍යාපාර / පරිශීලක තොරතුරු ලියාපදිංචි කිරීම",
organization_info: "ව්‍යාපාර තොරතුරු",
staff_info: "පරිශීලක තොරතුරු",
org_name: "ව්යාපාරික නාමය",
url: "URL",
org_scale: "පරිමාණ",
org_zip: "තැපැල් කේතය",
org_adress1: "ප්‍රාන්ත",
org_adress2: "මහ නගර සභාව",
org_adress3: "ලිපිනය / මහල් නිවාසයේ නම",
org_industry: "කර්මාන්තය",
org_category: "වර්ගය",
org_description: "විස්තර",
org_established_at: "ස්ථාපිත වර්ෂය",
org_phone: "ව්‍යාපාරික දුරකථන අංකය",
failed_established_at: "අවලංගු දිනය.",
staff_name: "පරිශීලක නාමය",
form_miss: "ආදාන පෝරමයේ වැරැද්දක් තිබේ.",
back_joboffer_detail: "රැකියා විස්තර වෙත ආපසු <",
create_joboffer: "රැකියාවක් සාදන්න",
edit_joboffer: "ජොබ් සංස්කරණය කරන්න",
stop_posting: "පළ කිරීම නවත්වන්න",
delete: "මකන්න",
job_title: "රැකියා තනතුර",
job_catch_phrase: "රැකියා ඇල්ලීමේ වාක්‍ය ඛණ්ඩය",
job_category: "වෘත්තීය කාණ්ඩය",
employed_company_name: "සේවයේ යොදවා ඇති සමාගමේ නම",
work_location: "සේවා ස්ථානය",
employment_status: "රැකියා තත්ත්වය",
full_time_employee: "පූර්ණ කාලීන සේවකයෙක්",
part_time_job: "අර්ධ කාලීන රැකියාව",
temporary_staff: "පිටත් කර යැවූ ශ්‍රමය",
contract_employee: "කොන්ත්‍රාත් සේවකයා",
intern: "සීමාවාසික",
subcontracting: "උප කොන්ත්‍රාත්තු",
contract: "කොන්ත්රාත්තුව",
new_graduate: "නව උපාධිධාරියෙක්",
salary: "වැටුප",
annual_income: "වාර්ෂික ආදායම",
monthly_salary: "මාසික වැටුප",
weekly_salary: "සති වැටුප",
dayly_salary: "දෛනික වැටුප",
job_offer_attension1: "නීතියට අනුකූලව වැඩ අන්තර්ගතය සඳහා නියමිත සේවා කොන්දේසි ආදිය පැහැදිලිව සඳහන් කිරීම අවශ්‍ය වේ.",
job_offer_attension2: "කරුණාකර නීතියෙන් පැහැදිලිව ප්‍රකාශ කිරීමට අවශ්‍ය සේවා කොන්දේසි යනාදිය පරීක්ෂා කර බලා වැඩ අන්තර්ගතය විස්තර කරන්න. (යොමුව: සෞඛ්‍ය, කම්කරු හා සුභසාධන අමාත්‍යාංශය, ප්‍රාන්ත කම්කරු කාර්යාංශය “කම්කරුවන් බඳවා ගන්නා සියලුම සමාගම්වලට”)",
job_offer_attension3: "ඔබ ඉලක්කගත පුද්ගලයාගේ වයස, ස්ත්‍රී පුරුෂ භාවය හෝ සමාජ තත්වය සීමා කරන භාෂාව භාවිතා කරන්නේ නම් රැකියා පළ නොකෙරේ.",
job_offer_attension4: "නිතර ප්‍රකාශයට පත් නොකළ උදාහරණ: &quot;20 ගණන්වලට සාදරයෙන් පිළිගනිමු&quot; &quot;යෞවනයන් (තරුණයින්) වෙත සාදරයෙන් පිළිගනිමු&quot; &quot;කාන්තාවන් සාදරයෙන් පිළිගනිමු / සීමිතයි&quot; &quot;සිසුන් පමණක්&quot;",
work_content_appeal: "වැඩ අන්තර්ගතය සහ අභියාචනා ලකුණු",
work_content_appeal_desc: "ඔබ මුලින් අභියාචනා කරුණු පැවසුවහොත් රැකියා සොයන්නන්ට උනන්දු වීම පහසු වනු ඇත.",
human_resources_seek: "මානව සම්පත්",
human_resources_seek_desc: "ඔබ සොයන කුසලතා පමණක් නොව, රැකියා සොයන්නන්ට සේවා ස්ථානය මවා ගැනීමට ඉඩ සලසන තොරතුරු ද අපි දැනුම් දෙමු.",
working_hours: "වැඩ කරන පැය",
traffic_access: "ගමනාගමන ප්‍රවේශය",
traffic_access_desc: "පොදු ප්‍රවාහන තොරතුරු වලට අමතරව, මෝටර් රථයෙන් ගමන් කිරීම සහ සේවකයින් සඳහා වාහන නැවැත්වීමේ ස්ථානයක් තිබේද නැද්ද යන්න වැනි තොරතුරු ඇතුළත් කරන්න.",
required: "අනිවාර්යයි",
optional: "කිසියම්",
other: "වෙනත්",
photo: "ඡායා රූප",
upload_video: "වීඩියෝ උඩුගත කරන්න",
job_tag: "රැකියා ටැග්",
until_select_three: "3 ක් දක්වා තෝරා ගත හැකිය",
senior_support: "ජ්‍යෙෂ් Senior සහාය",
salary_increase_promotion: "වැටුප් වැඩිවීමක් / උසස්වීමක් ඇත",
no_overtime: "අතිකාල නැත",
target_hiring_time: "ඉලක්ක කුලියට ගැනීමේ කාලය",
additional_questions: "අමතර ප්‍රශ්න",
job_offer_title: "රැකියා නම",
public: "නිදහස් කරන්න",
private: "පුද්ගලික",
public_status: "පොදු තත්වය",
occupation: "රැකියාව",
walfare: "ප්රතිකාර / සුභසාධනය",
create: "සාදන්න",
hour: "කාලය",
back_mypage: "මගේ පිටුවට ආපසු <",
job_offers: "රැකියා ලැයිස්තුගත කිරීම",
look_matches: "තරඟ ලැයිස්තුව බලන්න",
now_public: "දැන් විවෘත",
now_private: "පුද්ගලික",
check: "තහවුරු කරන්න",
edit2: "සංස්කරණය කිරීමට",
news_detail: "පුවත් විස්තර",
prefectures: "ප්‍රාන්ත",
hokkaido: "හොක්කයිඩෝ",
aomori: "අමෝරි",
iwate: "ඉවාට්",
miyagi: "මියාගි",
akita: "අකිටා",
yamagata: "යමගතා",
fukushima: "ෆුකුෂිමා",
ibaraki: "ඉබාරකි",
tochigi: "ටොචිගි",
gunma: "ගුන්මා",
saitama: "සයිටාමා",
chiba: "චිබා",
tokyo: "ටෝකියෝ",
kanagawa: "කනගාවා",
niigata: "නයිගාටා",
toyama: "ටොයාමා",
ishikawa: "ඉෂිකාවා",
fukui: "ෆුකුයි",
yamanashi: "යමානෂි",
nagano: "නාගානෝ",
gifu: "ගිෆු",
shizuoka: "ෂිසුඕකා",
aichi: "අයිචි",
mie: "ත්රිත්ව",
shiga: "ෂීගා",
kyoto: "කියොතෝ",
osaka: "ඔසාකා",
hyogo: "හයෝගෝ",
nara: "නාරා",
wakayama: "වාකයාමා",
tottori: "ටොටෝරි",
shimane: "ෂිමානේ",
okayama: "ඔකයාමා",
hiroshima: "හිරෝෂිමා",
yamaguti: "යමගුචි",
tokushima: "ටොකුෂිමා",
kagawa: "කගාවා",
echime: "එහයිම්",
kochi: "කොචි",
fukuoka: "ෆුකෝකා",
saga: "සාගා",
nagasaki: "නාගසාකි",
kumamoto: "කුමාමොටෝ",
oita: "ඔයිටා",
miyazaki: "මියාසාකි",
kagoshima: "කගොෂිමා",
okinawa: "ඔකිනාවා",
sinhalese: "සිංහල",
exam_region: "ප්‍රාන්ත",
exam_place_list: "ස්ථාන ලැයිස්තුව",
exam_place_name: "විභාග ස්ථානයේ නම",
care_evaluation_test: "දිගු කාලීන සත්කාර කුසලතා පුහුණු ඇගයීම් පරීක්ෂණය",
clean_building_test: "පිරිසිදු කිරීමේ කර්මාන්තය ගොඩනැගීම අතීත ගැටළු",
answer: "පිළිතුර",
skill_test_measurement: "නිපුණතා මිනුම් පරීක්ෂණය",
exam_problem: "විභාගය පිළිබඳ ප්‍රශ්නය",
fields: "කෙත්වතු සහ එළවළු",
gardening: "පහසුකම් ගෙවතු වගාව",
mushroom: "හතු",
fruit: "පළතුරු ගස",
dairy: "කිරි",
poultry: "කුකුළු ගොවිතැන",
pig: "Farm රු ගොවිතැන",
beginner: "ආරම්භකයා",
professional: "වෘත්තීය ශ්‍රේණිය",
advanced: "උසස්",
technical_training_test: "තාක්ෂණික සීමාවාසික පුහුණු ඇගයීම් පරීක්ෂණය",
exam_part: "විභාග ප්‍රශ්න වලින් කොටසක්",
tokoha_fruit: "ටෝකෝහා පලතුරු ගස",
deciduous_fruit: "පතනශීලී පලතුරු ගස",
ver: "සංස්කරණය",
errata: "errata",
form_work: "ආකෘති වැඩ ඉදිකිරීම",
construction: "ප්ලාස්ටර්",
tunnel_line: "උමං ප්‍රචාලන මාර්ගය",
earth_work: "භූමි වැඩ",
loofing: "සෙවිලි කිරීම",
elecommunication: "විදුලි සංදේශ",
reinforcing_contstruction: "බාර් ඉදිකිරීම ශක්තිමත් කිරීම",
reinforcing_joint: "තීරු සන්ධිය ශක්තිමත් කිරීම",
wall_painting: "පින්තාරු කිරීම (බිත්ති ආවරණය)",
board_finish: "පුවරු නිමාව, අභ්යන්තර නිමාව",
steeplejack: "පනින්න",
spray_insulation: "ඉසින ලද යූරීන් පරිවරණය",
marine_civil: "සමුද්‍ර සිවිල් ඉංජිනේරු විද්‍යාව",
concrete_pumping: "කොන්ක්‍රීට් පොම්ප කිරීම",
construction_machinery: "ඉදිකිරීම් යන්ත්රෝපකරණ ඉදිකිරීම",
learning_text: "පෙළ ඉගෙනීම",
basic_aircraft: "ගුවන් යානා මූලික තාක්ෂණ නිගමනය, විදුලි මිනුම්",
worksafety_quality: "වැඩ ආරක්ෂාව, ගුණාත්මකභාවය",
aircraft_overview: "ගුවන්යානා දළ විශ්ලේෂණය",
fish_general: "පොදුවේ ධීවර",
fish_safety: "ධීවර ආරක්ෂාව",
network_relations: "ධීවර විශේෂ කඹ සම්බන්ධතා",
fish_relations: "ධීවර විශේෂිත මසුන් ඇල්ලීම",
aquaculture_general: "පොදුවේ ජලජීවී වගාව",
feeding_aquaculture: "ජලජීවී වගා විශේෂත්වය ජලජීවී වගාව පෝෂණය කිරීම",
unfed_aquaculture: "ජලජීවී වගා විශේෂත්වය නොකැඩූ ජලජීවී වගාව",
attachment: "ඇමුණුම",
glossary: "ටීකාව",
feneral_customer: "සාමාන්‍ය පාරිභෝගික සේවය",
food_dring_cooking: "ආහාර පාන ආහාර පිසීම",
hygiene_management: "සනීපාරක්ෂක කළමනාකරණය",
visa_application: "නිශ්චිත නිපුණතා වීසා බලපත්‍ර අයදුම්පත",
certificate_residence_tax: "1. පදිංචිය පිළිබඳ සහතිකය (පසුගිය වසර සඳහා)",
salary_income_withholding : "2. වැටුප් ආදායම සඳහා රඳවා ගැනීමේ ස්ලිප් පිටපතක්",
national_health_insured: "3. ජාතික සෞඛ්‍ය රක්‍ෂණ රක්‍ෂණය කළ පුද්ගලයාගේ කාඩ්පතෙහි පිටපතක් (පුද්ගලයා ලියාපදිංචි කර ඇත්නම්)",
national_health_payment: "4. ජාතික සෞඛ්‍ය රක්‍ෂණ වාරික ගෙවීම් සහතිකය",
national_health_receipt: "5. ජාතික සෞඛ්‍ය රක්‍ෂණ වාරික රිසිට් පතේ පිටපතක්",
technical_intern_training2: "6. තාක්ෂණික සීමාවාසික පුහුණුව අංක 2 සාර්ථකව අවසන් කර ඇති බවට සහතික කරන ලියකියවිලි",
need_the_following : "ඔබට පහත සඳහන් දේවලින් එකක් අවශ්‍ය වේ:",
pass_certificate_test_specialized : "Evalu නිපුණතා ඇගයීම් පරීක්ෂණයේ (විශේෂිත ශ්‍රේණිය) ප්‍රායෝගික නිපුණතා පරීක්ෂණයේ සමත් සහතිකයේ පිටපතක්",
technical_intern_training3: "නිපුණතා පරීක්ෂණයේ ප්‍රායෝගික පරීක්ෂණයේ සමත් සහතිකයේ පිටපතක් (3 ශ්‍රේණිය)",
evaluation_record_technical_intern: "Exam ඔබ ඉහත විභාගය සමත් නොවන්නේ නම්, ඔබ තාක්ෂණික අභ්‍යාසලාභීන් සඳහා ඇගයීම් වාර්තාව පිරවිය යුතුය.",
cartificate_pass_basic_test: "7.6 ට විකල්පයක් ලෙස, ඔබට ජපන් පදනමේ ජපන් මූලික පරීක්ෂණයෙන් සමත් වීමේ සහතිකයේ පිටපතක් හෝ ජපන් භාෂා ප්‍රවීණතා පරීක්ෂණයේ (එන් 4) හෝ ඊට වැඩි සාමාර්ථ සහතිකයේ පිටපතක් ඉදිරිපත් කළ හැකිය.",
change_permission_application: "8. වෙනස් කිරීමේ අවසර පත්‍රයේ ඡායාරූපය (සිරස් 4 සෙ.මී. x තිරස් 3 සෙ.මී.)",
resume_data_time_entry: "9. ඇතුළත් වන අවස්ථාවේ දත්ත නැවත ආරම්භ කරන්න",
select_file: "ගොනු තෝරන්න",

description_movie: "පැහැදිලි කිරීමේ වීඩියෝව",
how_to_use_movie: "වීඩියෝ භාවිතා කරන්නේ කෙසේද",
movie_news: "1. විශේෂිත නිපුණතා වීසා බලපත්‍ර පිළිබඳ පුවත්",
movie_exam: "2. පරීක්ෂණ දිනය දක්වා ඉතිරිව ඇති දින ගණන",
movie_predict_pass: "3. ඇස්තමේන්තුගත සමත් අනුපාතය",
movie_ave_study_test: "4. ඔබ අධ්‍යයනය කළ ඔබේම පරීක්ෂණයක සාමාන්‍ය ලකුණු",
movie_similar_exam: "5. සමාන විභාග ප්‍රශ්න",
movie_learning_text: "6. ඉගෙනුම් පෙළ පොත (පෙළ පොත) බාගන්න",
movie_solved_exam: "7. මා අතීතයේ විසඳූ ගැටළු",
movie_pased_exam: "8. ඇත්ත වශයෙන්ම පෙනී ගිය අතීත ගැටළු දැකීම ගැන",
movie_resume_regist: "9. ඇතුළත් වන අවස්ථාවේ ලියාපදිංචිය නැවත ආරම්භ කරන්න",
movie_pass_document_regist: "10. ප්‍රවීණතා පරීක්ෂණ සමත් වීම",
movie_agency_service: "11. විභාග අයදුම්පත් නියෝජිත සේවය",
movie_consule_service: "12. උපදේශන සේවය ඉගෙනීම",
description_movie_trans: "ඔබට ජපන් භාෂාව හැර වෙනත් භාෂාවකින් නැරඹීමට අවශ්‍ය නම්, ගියර් සලකුණ ක්ලික් කරන්න, උපසිරැසි සහ ස්වයංක්‍රීය පරිවර්තනය ක්ලික් කරන්න, ඔබේ මව් භාෂාව තෝරන්න, ඉන්පසු නරඹන්න.",
combodia: 'combodia',

}
